export const PAGE_FIX_ACCESSIBILITY_CHECK_TAB = {
    WEBSITE_STRUCTURE: 'website_structure',
    DESIGN: 'design',
    LINKS: 'links',
    MEDIA: 'media',
} as const;
